import { MESSAGING_POLL_INTERVAL_MS } from "@src/features/messaging/new/constants";

import { useMessagingActivityUnreadCountQuery } from "./MessagingActivityNavItem.generated";
import { POST_ACTIVITY_TYPES } from "./postActivityTypes";

export const useMessagingActivityUnreadCount = (skip: boolean): number => {
  const { data } = useMessagingActivityUnreadCountQuery({
    variables: { types: POST_ACTIVITY_TYPES },
    skip,
    pollInterval: MESSAGING_POLL_INTERVAL_MS,
  });
  return data?.MessagingActivityItems.totalCount ?? 0;
};

export default useMessagingActivityUnreadCount;
